import { PlansPlanMode } from '../../../api/types'
import { PlansListErrorState } from '../../lumpsum-ui-components/PlansListErrorState'

type IdealPlansListErrorStateProps = {
  onRetry: () => void
}

export function IdealPlansListErrorState({ onRetry }: IdealPlansListErrorStateProps) {
  return <PlansListErrorState planMode={PlansPlanMode.IDEAL_PORTFOLIO} onRetry={onRetry} />
}
